/**
 * @file RefreshControl atom — pull-to-refresh primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/RefreshControl
 */
export { RefreshControl } from "@/components/ui/refresh-control";
